const getRuntimeConfigValues = (publicRuntimeConfig)=>{
    var ref;
    var ref1;
    const { APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_TYPE_ID , APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_STORE_CODE , APPOINTMENT_BOOKING_ALTERNATIVE_URL_STORES ,  } = (ref1 = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : (ref = publicRuntimeConfig.grandvision) === null || ref === void 0 ? void 0 : ref.featureConfigs) !== null && ref1 !== void 0 ? ref1 : {};
    const virtualAppointmentTypeId = typeof APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_TYPE_ID === 'string' ? APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_TYPE_ID : undefined;
    const virtualStoreCode = typeof APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_STORE_CODE === 'string' ? APPOINTMENT_BOOKING_VIRTUAL_APPOINTMENT_STORE_CODE : undefined;
    const alternativeUrlStores = typeof APPOINTMENT_BOOKING_ALTERNATIVE_URL_STORES === 'string' ? APPOINTMENT_BOOKING_ALTERNATIVE_URL_STORES : undefined;
    return {
        virtualStoreCode,
        virtualAppointmentTypeId,
        alternativeUrlStores
    };
};

export { getRuntimeConfigValues };
//# sourceMappingURL=get-runtime-config-values.js.map
